@if ({}; as STATE) {
  <section class="subscriber-channel-card"></section>
}
